<template>
  <v-form ref="form">
    <v-card-text>
      <v-row>
        <v-col>
          <v-text-field filled
                        hide-details="auto"
                        v-bind:label="$t('title')"
                        v-bind:rules="[ rules.required ]"
                        v-model="department.title" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-autocomplete filled clearable
                          hide-details="auto"
                          v-bind:items="trainees | items({ text: v => `${v.givenName} ${v.familyName}`, value: 'id' })"
                          v-bind:label="$t('supervisor')"
                          v-model="department.supervisorId" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('global.pleaseFillOutThisField')
        }
      },
      ...mapGetters({
        trainees: 'learning/trainees'
      })
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'DepartmentDetails',
    props: {
      department: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "title": "Bezeichnung",
      "supervisor": "Abteilungsleiter"
    },
    "en": {
      "title": "Title",
      "supervisor": "Supervisor"
    }
  }
</i18n>